import { render, staticRenderFns } from "./MatchCounter.vue?vue&type=template&id=5068db0e&scoped=true&"
import script from "./MatchCounter.vue?vue&type=script&lang=js&"
export * from "./MatchCounter.vue?vue&type=script&lang=js&"
import style0 from "./MatchCounter.vue?vue&type=style&index=0&id=5068db0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068db0e",
  null
  
)

export default component.exports